var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.starCount),function(index){return _c('i',{key:index,staticClass:"text-shadow star",class:_vm.getIconClass(index),attrs:{"title":index},on:{"click":function($event){return _vm.onClick(index)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }